import Error500 from './Error500';

const GenericError = (props) => <Error500 {...props} />;

export default GenericError;
